import { IconButton, ListItem, styled } from "@material-ui/core";
import CheckIcon from '@material-ui/icons/Check';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import { Collection, Linked } from "@type-r/models";
import { Column, Columns, PopupDialog, PrimaryButton } from "lqx-react";
import React, { useMemo } from "react";
import { SmallLoading } from "../../invoices/statement/dialogs/report-actions";
import { ExternalSystem } from "../api/externalSystemRequest";
import { useCollection, useIO, useLinked } from "@type-r/react";
import { AssetEventFailureMessagesCount } from "../api/assetEventFailureMessagesCount";

export const InblockedAssetsTitle = ({ assetChanges, externalSystems, $filter, $loadedAssetEvents, importJobId, itemsCount, assetEventsGeneralCount }:
    { assetChanges: Collection<any>, externalSystems: ExternalSystem[], $filter, $loadedAssetEvents: Linked<boolean>, importJobId?, itemsCount?, assetEventsGeneralCount?}) => {
    const [selectedIndex, setSelectedIndex] = React.useState<any>();

    const externalSystemsDictionary = useMemo(() => {
        const dictionary = {};
        externalSystems.forEach(item => {
            dictionary[item.assetEventType] = item;
        });
        return dictionary;
    }, [externalSystems['_changeToken']]);

    const assetEventFailureMessagesCount = useCollection.of(AssetEventFailureMessagesCount);
    const $isModalOpen = useLinked({ externalSystemTitle: '', isOpen: false });

    const isReadyFailureMessagesCount = useLinked(false);
    const fetchData = async () => {
        try {
            await assetEventFailureMessagesCount.fetch({ params: { importJobId: importJobId } }).catch(e => console.error(e));
            isReadyFailureMessagesCount.set(true);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const assetEventTypes = externalSystems.map(item => item.assetEventType);

    const handleDialogClose = (e) => {
        e.stopPropagation();
        e.preventDefault();
        $isModalOpen.set({ isOpen: false, externalSystemTitle: '' });
    };

    return <>
        <HeaderColumn>
            <StateColumn>
                Digitized ({itemsCount})
            </StateColumn>
            {assetChanges.length == 0 ? <></> : <>
                {$loadedAssetEvents.value ?
                    <MessagesColumn>
                        {
                            assetEventsGeneralCount &&
                            assetEventsGeneralCount.filter((event) => assetEventTypes.includes(event.eventTypeId))
                                .sort((a, b) => b.success - a.success)
                                .map((ae, index) =>
                                    <ListItem
                                        style={ae.success ? Success : Warning}
                                        button
                                        selected={selectedIndex === index}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setSelectedIndex(selectedIndex != index ? index : -1);
                                            $filter.set({
                                                ...$filter.value,
                                                eventType: selectedIndex != index ?
                                                    { eventTypeId: ae.eventTypeId, success: ae.success } : null
                                            });
                                        }}
                                        key={index}>
                                        {ae.success ? <CheckIcon /> : <WarningIcon />} <Space /> {ae.count} {!ae.success ?
                                            <>{externalSystemsDictionary[ae.eventTypeId].globalFailMessage}
                                                <IconButton aria-label="Info" size="small" style={InfoButton}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        fetchData();
                                                        $isModalOpen.set({ isOpen: true, externalSystemTitle: `${ae.count} ${externalSystemsDictionary[ae.eventTypeId].globalFailMessage}` })
                                                    }}>
                                                    <InfoIcon style={Info} />
                                                </IconButton></> :
                                            externalSystemsDictionary[ae.eventTypeId].globalSuccessMessage}
                                    </ListItem>)
                        }
                    </MessagesColumn> : <SmallLoading />
                }</>
            }
        </HeaderColumn>
        {$isModalOpen.value.isOpen ?
            <PopupDialog onClose={e => { handleDialogClose(e) }}
                onClick={(e) => e.stopPropagation()}
                title={$isModalOpen.value.externalSystemTitle}
                actions={
                    <>
                        <PrimaryButton onClick={e => { handleDialogClose(e) }}>Close</PrimaryButton>
                    </>
                }
                maxWidth='md'
                hideTitle={false}>
                {isReadyFailureMessagesCount.value ?
                    <StyledBlock>
                        {assetEventFailureMessagesCount.models.map((item, index) =>
                            <ListItem style={Warning}>
                                <WarningIcon /> <Space /> <><CountBlock>{item.count}</CountBlock> - {item.message}</>
                            </ListItem>
                        )}
                    </StyledBlock>
                    : <SmallLoading />}
            </PopupDialog> : <></>}
    </>
}

const Space = styled("div")({
    width: '5px'
});

const CountBlock = styled("span")({
    paddingLeft: '5px',
    paddingRight: '10px',
    fontWeight: 'bold'
});

const StyledBlock = styled("div")({
    paddingLeft: '20px'
});

const StateColumn = styled(Column)({
    width: '20%',
    maxWidth: '20%',
    marginLeft: '10px'
});

const MessagesColumn = styled(Column)({
    width: '80%',
    fontSize: '11px'
});

const HeaderColumn = styled(Columns)({
    marginTop: '10px',
    marginBottom: '5px'
});

const InfoButton = {
    marginLeft: '5px'
};

const Info = {
    color: "#eabc5e",
    width: '17px'
};

const Warning = {
    color: "#eabc5e",
    padding: '1px'
};
const Success = {
    color: "#4197d6",
    padding: '1px'
};
